/* eslint-disable */
import React, { Component, Fragment } from 'react'
import gql from 'graphql-tag'
import MUIDataTable from 'mui-datatables'
import { Query, withApollo } from 'react-apollo'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Select from 'react-select'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'
import getLoginId from '../../../utils/getLoginId'
import FormHelperText from '@material-ui/core/FormHelperText'

import { DatePicker } from 'material-ui-pickers'
import moment from 'moment'
//TODO :add client NAme in row and update onClickRow fn
const GET_VEHICLE_SERIAL_NUMBERS = gql`
  query getVehicleSerialNumbers($partnerLoginId: Int!) {
    vtsNos: getVehicleSerialNumbers(partnerLoginId: $partnerLoginId) {
      vtsNo
      clientLoginId
    }
  }
`
const SET_SPARE_PART = gql`
  mutation setSparePart(
    $sparePartConfigs: [SparePartConfig!]
    $clientLoginId: Int
  ) {
    setSparePartReplacement(
      sparePartConfigs: $sparePartConfigs
      clientLoginId: $clientLoginId
    )
  }
`
const GET_CLIENTS = gql`
  query allClientDetails($partnerLoginId: Int, $status: Int) {
    clientsDetails: allClientDetails(
      partnerLoginId: $partnerLoginId
      status: $status
    ) {
      clientName

      loginId
      partner {
        businessName
      }
    }
  }
`

const GET_SPAREPARTS_REPLACEMENT_HISTORY = gql`
  query getSpareAdmin($partnerLoginId: Int!) {
    sparePartsHistory: getSparePartHistoryForAdmin(
      partnerLoginId: $partnerLoginId
    ) {
      sparePartName
      sparePartNumber
      description
      replacedPartNumber
      replacedBy
      replacedDate
      uniqueDeviceId
      clientLoginId
    }
  }
`

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  dense: {
    marginTop: 16
  },
  button: {
    margin: theme.spacing.unit * 1
  }
})

class SparePartReplacement extends Component {
  state = {
    vtsNos: [],
    //creation variables
    toBeDeleted: false,
    dataToBeDeleted: null,
    toUpdate: false,
    vehicleSerialNo: '',
    sparePartNumber: '',
    sparePartReplacementHistory: [],
    sparePartsTableLoading: true,
    sparePartName: '',
    clientName: '',
    status: 1,
    clientsDetails: [],
    description: '',
    replacedPartNumber: '',
    replacedBy: '',
    partnerLoginId: getLoginId(),
    replacedDate: {
      date: moment(),
      unix: moment()
        .unix()
        .toString()
    },
    clientVtsNos: []
  }
  columns = [
    'CLIENT NAME',
    'UNIQUE DEVICE ID',
    'SPARE PART NAME',
    'SPARE PART NUMBER',
    'DESCRIPTION',
    'REPLACED PART NUMBER',
    'REPLACED BY',
    'REPLACED DATE'
  ]
  options = {
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 15,
    onRowClick: (rowData, dataIndex, rowIndex) => {
      // console.log('meena', this.entityId[rowIndex])
      let rD = rowData[7]
      let unixTs = moment(`${rD}`).format('X')
      let newReplacedDate = {
        date: rD,
        unix: unixTs
      }
      let clientLoginId = this.getClientLoginId(rowData[0])
      this.setState(
        {
          clientName: clientLoginId,
          vehicleSerialNo: rowData[1],
          sparePartName: rowData[2],
          sparePartNumber: rowData[3],
          description: rowData[4],
          replacedPartNumber: rowData[5],
          replacedBy: rowData[6],
          replacedDate: newReplacedDate,
          toUpdate: true,
          dataToBeDeleted: dataIndex.rowIndex
        },
        this.getClientVtsNos
      )
    }
  }

  getFormattedDate = timestamp => moment(timestamp * 1000).format('YYYY/MM/DD')

  handleVtsNoChange = async event => {
    this.setState({ vehicleSerialNo: event.value })
  }
  getAllClients = async () => {
    const clientsDetails = await this.props.client.query({
      query: GET_CLIENTS,
      variables: {
        partnerLoginId: parseInt(this.state.partnerLoginId, 10),
        status: parseInt(this.state.status, 10)
      },
      fetchPolicy: 'network-only'
    })
    // console.log(clientsDetails)
    const allClients = clientsDetails.data.clientsDetails.map(client => ({
      value: client.loginId,
      label: client.clientName
    }))
    this.setState({ clientsDetails: allClients })
  }
  mapToArr(spareParts) {
    var rowData = []
    var fullData = []
    spareParts.forEach((element, index) => {
      rowData = []
      // console.log(element)
      let description = element.description ? element.description : 'NA'
      let clientName = this.getClientName(element.clientLoginId)
      rowData.push(clientName)
      rowData.push(element.uniqueDeviceId)
      rowData.push(element.sparePartName)
      rowData.push(element.sparePartNumber)
      rowData.push(description)
      rowData.push(element.replacedPartNumber)
      rowData.push(element.replacedBy)
      rowData.push(this.getFormattedDate(element.replacedDate))
      // console.log(rowData)
      fullData.push(rowData)
    })
    this.setState({
      sparePartReplacementHistory: fullData,
      sparePartsTableLoading: false
    })
  }

  getClientName = clientLoginId => {
    console.log(clientLoginId)
    let clientName = 'NA'
    this.state.clientsDetails.forEach((client, index) => {
      if (client.value === clientLoginId) {
        clientName = client.label
      }
    })
    return clientName
  }
  getClientLoginId = clientLoginValue => {
    console.log(clientLoginValue)
    let clientValue
    this.state.clientsDetails.forEach((client, index) => {
      if (client.label === clientLoginValue) {
        clientValue = client.value
      }
    })
    return clientValue
  }
  handleInputChange = key => e => {
    const {
      vehicleSerialNo,
      sparePartNumber,
      sparePartName,
      description,
      replacedPartNumber,
      replacedBy,
      replacedDate
    } = this.state
   
    if (
      sparePartNumber.length < 25 ||
      sparePartName.length < 30 ||
      replacedPartNumber.length < 25 ||
      description.length < 71 ||
      replacedBy.length < 51
    ) {
      this.setState({ [key]: e.target.value })
    }
    
  }
  getVtsNos = async () => {
    let loginId = parseInt(localStorage.getItem('Login_id'), 10)
    const { data } = await this.props.client.query({
      query: GET_VEHICLE_SERIAL_NUMBERS,
      variables: {
        partnerLoginId: loginId
      },
      fetchPolicy: 'network-only'
    })
    const allVtsNos = data.vtsNos.map(vtsNo => ({
      value: vtsNo.vtsNo,
      label: vtsNo.vtsNo,
      clientLoginId: vtsNo.clientLoginId
    }))
    // console.log('data', allVtsNos)
    this.setState({ vtsNos: allVtsNos })
  }

  getSparePartsReplacementHistory = async () => {
    let loginId = parseInt(localStorage.getItem('Login_id'), 10)
    const { data } = await this.props.client.query({
      query: GET_SPAREPARTS_REPLACEMENT_HISTORY,
      variables: {
        partnerLoginId: loginId
      },
      fetchPolicy: 'network-only'
    })
    this.mapToArr(data.sparePartsHistory)
  }
  handleDelete = async event => {
    //TODO Construct here.
    event.preventDefault()
    const {
      toBeDeleted,
      vehicleSerialNo,
      sparePartNumber,
      sparePartName,
      description,
      replacedPartNumber,
      sparePartReplacementHistory,
      dataToBeDeleted,
      replacedBy,
      replacedDate,
      clientName
    } = this.state
    let newReplacedDate = parseInt(replacedDate.unix)
    let loginId = parseInt(localStorage.getItem('Login_id'), 10)
    const { data, errors } = await this.props.client.mutate({
      mutation: SET_SPARE_PART,
      variables: {
        sparePartConfigs: [
          {
            toBeDeleted: true,
            uniqueDeviceId: vehicleSerialNo,
            sparePartNumber,
            sparePartName,
            description,
            replacedPartNumber,
            replacedBy,
            replacedDate: newReplacedDate
          }
        ],
        clientLoginId: clientName
      },
      errorPolicy: 'all'
    })
    if (data) {
      this.props.openSnackbar('Spare Part deleted successfully')

      this.setState(
        {
          sparePartsTableLoading: true,
          sparePartName: '',
          sparePartNumber: '',
          replacedPartNumber: '',
          replacedDate: {
            date: moment(),
            unix: moment()
              .unix()
              .toString()
          },
          replacedBy: '',
          vehicleSerialNo: '',
          clientName: '',
          description: '',
          toBeDeleted: false,
          dataToBeDeleted: null,
          toUpdate: false
        },
        this.getSparePartsReplacementHistory
      )
    } else {
      console.log(errors, 'err')
      this.props.openSnackbar(errors[0].message)
    }
  }
  checkSpNoIsPresent = (sparePartReplacementHistory, sparePartNumber) => {
    let sparePartNumberPresent = false
    sparePartReplacementHistory.forEach((ArrayElement, index) => {
      if (ArrayElement[3] === sparePartNumber) {
        sparePartNumberPresent = true
      }
    })
    return sparePartNumberPresent
  }
  handleSubmit = async event => {
    //TODO Construct here.
    event.preventDefault()
    const {
      toBeDeleted,
      vehicleSerialNo,
      sparePartNumber,
      sparePartName,
      description,
      replacedPartNumber,
      replacedBy,
      replacedDate,
      clientName,
      toUpdate,
      dataToBeDeleted,
      sparePartReplacementHistory
    } = this.state
    let newReplacedDate = parseInt(replacedDate.unix)
    console.log(
      toBeDeleted,
      vehicleSerialNo,
      sparePartNumber,
      sparePartName,
      description,
      replacedPartNumber,
      replacedBy,
      replacedDate,
      clientName,
      toUpdate,
      dataToBeDeleted
    )
    let loginId = parseInt(localStorage.getItem('Login_id'), 10)
    if (!toUpdate) {
      let sparePartNumberIsPresent = this.checkSpNoIsPresent(
        sparePartReplacementHistory,
        sparePartNumber
      )
      if (!sparePartNumberIsPresent) {
        const { data, errors } = await this.props.client.mutate({
          mutation: SET_SPARE_PART,
          variables: {
            sparePartConfigs: [
              {
                toBeDeleted,
                uniqueDeviceId: vehicleSerialNo,
                sparePartNumber,
                sparePartName,
                description,
                replacedPartNumber,
                replacedBy,
                replacedDate: newReplacedDate
              }
            ],
            clientLoginId: clientName
          },
          errorPolicy: 'all'
        })
        console.log(data)
        if (data) {
          this.props.openSnackbar('Spare Part operation successful')
          this.setState(
            {
              sparePartsTableLoading: true,
              sparePartName: '',
              sparePartNumber: '',
              replacedPartNumber: '',
              replacedDate: {
                date: moment(),
                unix: moment()
                  .unix()
                  .toString()
              },
              replacedBy: '',
              vehicleSerialNo: '',
              clientName: '',
              description: '',
              toBeDeleted: false,
              dataToBeDeleted: null,
              toUpdate: false
            },
            this.getSparePartsReplacementHistory
          )
        } else {
          console.log(errors, 'err')
          this.props.openSnackbar(errors[0].message)
        }
      } else {
        this.setState({ sparePartNumber: '' })
        this.props.openSnackbar('Spare Part Number Already Present')
      }
    } else {
      const { data, errors } = await this.props.client.mutate({
        mutation: SET_SPARE_PART,
        variables: {
          sparePartConfigs: [
            {
              toBeDeleted,
              uniqueDeviceId: vehicleSerialNo,
              sparePartNumber,
              sparePartName,
              description,
              replacedPartNumber,
              replacedBy,
              replacedDate: newReplacedDate
            }
          ],
          clientLoginId: clientName
        },
        errorPolicy: 'all'
      })
      console.log(data)
      if (data) {
        this.props.openSnackbar('Spare Part operation successful')
        this.setState(
          {
            sparePartsTableLoading: true,
            sparePartName: '',
            sparePartNumber: '',
            replacedPartNumber: '',
            replacedDate: {
              date: moment(),
              unix: moment()
                .unix()
                .toString()
            },
            replacedBy: '',
            vehicleSerialNo: '',
            clientName: '',
            description: '',
            toBeDeleted: false,
            dataToBeDeleted: null,
            toUpdate: false
          },
          this.getSparePartsReplacementHistory
        )
      } else {
        console.log(errors, 'err')
        this.props.openSnackbar(errors[0].message)
      }
    }
  }

  async componentDidMount() {
    await this.getVtsNos(this.props.client)
    if (this.props.match.params.loginId === undefined) {
      await this.getAllClients()
    } else {
      await this.getAllClients()
      await this.handleChangeClient()
    }
    await this.getSparePartsReplacementHistory(this.props.client)
  }
  getClientVtsNos = () => {
    let allVtsNos = [...this.state.vtsNos]
    let clientName = this.state.clientName
    let clientVtsNos = []
    allVtsNos.forEach((vts, index) => {
      if (vts.clientLoginId === clientName) {
        clientVtsNos.push(allVtsNos[index])
      }
    })
    this.setState({ clientVtsNos: clientVtsNos })
  }

  handleCancel = () => {
    this.setState({
      sparePartName: '',
      sparePartNumber: '',
      replacedPartNumber: '',
      replacedDate: {
        date: moment(),
        unix: moment()
          .unix()
          .toString()
      },
      replacedBy: '',
      vehicleSerialNo: '',
      clientName: '',
      description: '',
      toBeDeleted: false,
      dataToBeDeleted: null,
      toUpdate: false
    })
  }

  handleDateChange = name => date => {
    let tempDate = this.state[name]
    tempDate.date = date
    console.log(date)
    tempDate.unix = moment(date)
      .unix()
      .toString()
    this.setState({ [name]: tempDate })
  }
  handleChangeClient = async e => {
    let cltId = parseInt(e.value, 10)
    this.setState(
      { clientName: cltId, vehicleSerialNo: '' },
      this.getClientVtsNos
    )
   
  }

  render() {
    console.log(this.state)
    console.log(this.props);
    const { classes } = this.props
    const {
      vehicleSerialNo,
      sparePartNumber,
      sparePartName,
      description,
      replacedPartNumber,
      replacedBy,
      replacedDate,
      sparePartReplacementHistory,
      sparePartsTableLoading,
      toUpdate
    } = this.state
    return (
      <div className={classes.root}>
        <Typography variant="title" gutterBottom>
          <p>
            Spare Part Replacement Details <br />
            <br />
          </p>
        </Typography>
        <Grid container spacing={16}>
          <Grid container>
            <Grid container className="searchdiv" spacing={8} justify="center">
              <Grid item xs={12} sm={12}>
                <label
                  style={{
                    marginRight: '20px'
                  }}
                >
                  Customer Name :
                </label>

                <FormControl
                  style={{
                    minWidth: '50%'
                  }}
                >
                  <FormGroup className="form-input">
                    <Select
                      classes={classes}
                      options={this.state.clientsDetails}
                      value={this.state.clientName}
                      onChange={this.handleChangeClient}
                      placeholder="Select Customer *"
                      // disabled={this.state.toUpdate}
                    />
                    
                    <FormHelperText
                      id="name-error-text"
                      className="Error_msg"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid item xs={12}>
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <Select
                    classes={classes.paper}
                    options={this.state.clientVtsNos}
                    // components={components}
                    value={this.state.vehicleSerialNo}
                    onChange={this.handleVtsNoChange}
                    placeholder="Select unique device Id"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} fullwidth="true">
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      disabled={toUpdate}
                      id="sparePartNumber"
                      name="sparePartNumber"
                      className="textfield"
                      margin="dense"
                      label="Spare Part Number"
                      // type="Multi-line"
                      value={this.state.sparePartNumber}
                      required
                      onChange={this.handleInputChange('sparePartNumber')}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>{' '}
              <Grid item xs={12} sm={12} fullwidth="true">
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      id="sparePartName"
                      name="sparePartName"
                      className="textfield"
                      margin="dense"
                      label="Spare part name"
                      value={this.state.sparePartName}
                      required
                      onChange={this.handleInputChange('sparePartName')}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} fullwidth="true">
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      id="description"
                      name="description"
                      className="textfield"
                      margin="dense"
                      label="Description"
                      value={this.state.description}
                      onChange={this.handleInputChange('description')}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>{' '}
            </Grid>
            <Grid item xs={6}>
              <Grid item xs={12} sm={12} fullwidth="true">
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      id="replacedPartNumber"
                      name="replacedPartNumber"
                      className="textfield"
                      margin="dense"
                      label="Replaced part number"
                      value={this.state.replacedPartNumber}
                      required
                      onChange={this.handleInputChange('replacedPartNumber')}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} fullwidth="true">
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      id="replacedBy"
                      name="replacedBy"
                      className="textfield"
                      margin="dense"
                      label="Replaced by"
                      // type="Multi-line"
                      value={this.state.replacedBy}
                      required
                      onChange={this.handleInputChange('replacedBy')}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>{' '}
              <Grid item xs={12} sm={12} fullwidth="true">
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <DatePicker
                      format="DD/MM/YYYY"
                      maxDate={new Date()}
                      value={this.state.replacedDate.date}
                      onChange={this.handleDateChange('replacedDate')}
                      label="Replaced date"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <FormGroup
          className="form-input"
          style={{
            padding: '25px'
          }}
        >
          <Grid justify="left" container>
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={this.handleSubmit}
              disabled={
                vehicleSerialNo === '' ||
                sparePartNumber === '' ||
                sparePartName === '' ||
                replacedPartNumber === '' ||
                replacedBy === ''
              }
            >
              ↪ Submit
            </Button>
            {toUpdate && (
              <Fragment>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={this.handleDelete}
                >
                  🗑️ Delete
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  className={classes.button}
                  onClick={this.handleCancel}
                >
                  ❌ Cancel
                </Button>
              </Fragment>
            )}
          </Grid>
        </FormGroup>
        <Grid item xs={12}>
          {sparePartsTableLoading ? (
            <div>Loading...</div>
          ) : (
            <MUIDataTable
              data={sparePartReplacementHistory}
              columns={this.columns}
              options={this.options}
            />
          )}
        </Grid>
      </div>
    )
  }
}

export default withStyles(style)(
  withApollo(withSharedSnackbar(SparePartReplacement))
)



// WEBPACK FOOTER //
// ./src/components/Pages/SparePartReplacement/index.jsx